import { render, staticRenderFns } from "./Lectors.vue?vue&type=template&id=6aa65ba4&scoped=true"
import script from "./Lectors.vue?vue&type=script&lang=js"
export * from "./Lectors.vue?vue&type=script&lang=js"
import style0 from "./Lectors.vue?vue&type=style&index=0&id=6aa65ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa65ba4",
  null
  
)

export default component.exports